import { InventoryKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetInventoryBalanceRequest, GetInventoryBalanceResponse } from "@maven-rest/billing/Inventory.dto";
import { InventoryUrl } from "@maven-rest/billing/Inventory.url";

export function useInventoryBalanceQuery(
  req: GetInventoryBalanceRequest,
  options?: SimpleQueryOptions<GetInventoryBalanceResponse, GetInventoryBalanceRequest>
) {
  return useBaseQuery({
    queryKey: [InventoryKey.InventoryBalance, String(req.organizationId), req.functionality],
    fnOption: {
      host: process.env.REACT_APP_BILLING_BE_URL,
      url: InventoryUrl.getInventoryBalance,
      request: req,
    },
    ...options,
  });
}
